$(document).ready(function () {
  // File Upload CV
  function fileUploadCV() {
    try {
      let idOfInput = '#CVUpload'
      let onUploadedFileIconSet = 'assets/media/images/document-circle-green-icon.svg'

      let inputEl = $(document).find(idOfInput)
      if (!inputEl.length) return

      $(document).on('change', inputEl, function (e) {
        let [file] = e.target.files

        $('.js-form-group__icon').attr('src', `${onUploadedFileIconSet}`)
        $('.js-form-group--file-upload').addClass('preview-v2')
        $('.js-form-group__prompt').addClass('preview-v2')
        $('.js-text-header').text(`${file.name}`)
        $('.js-text-sub-header').parent().remove()
      })

      $(document).on('click', '.js-form-group__change-link', function () {
        inputEl.click()
      })

      $(document).on('click', '.js-form-group__preview-link', function () {
        let files = inputEl.get(0).files
        if (!files.length) return

        let [file] = files
        let url = URL.createObjectURL(file)
        window.open(url, '_blank')
      })
    } catch (error) {
      console.log('You need to Sign In first before to apply')
    }
  }

  function coverLetterQuillEditor() {
    try {
      let editorOption = {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'header': '1' }, { 'header': '2' }],
            [{ 'align': [] }, { 'list': 'bullet' }],
            ['link']
          ]
        },
        theme: 'snow',
        placeholder: 'Cover Letter / Job Description'
      }

      let editor = new Quill('.js-cover-letter-editor', editorOption)

      if (editor.container) {
        let historyButton = `<span class="ql-formats float-end" style="margin-right: 0 !important;">
        <button type="button" class="ql-undo">
          <svg width="18" height="8" viewBox="0 0 18 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path class="ql-fill" d="M7.4 1.4C5.7 1.7 4.2 2.3 2.8 3.4L0 0.5V7.5H7L4.3 4.8C8 2.2 13.1 3 15.8 6.7C16 7 16.2 7.2 16.3 7.5L18.1 6.6C15.9 2.8 11.7 0.7 7.4 1.4Z"/>
          </svg>
        </button>
        <button type="button" class="ql-redo">
        <svg width="18" height="8" viewBox="0 0 18 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="ql-fill" d="M10.6 1.4C12.3 1.7 13.8 2.3 15.2 3.4L18 0.5V7.5H11L13.7 4.8C10 2.1 4.9 3 2.3 6.7C2.1 7 1.9 7.2 1.8 7.5L0 6.6C2.1 2.8 6.3 0.7 10.6 1.4Z"/>
        </svg>
        </button>
      </span>`

        $(document).find('.js-cover-letter-editor').siblings('.ql-toolbar').append(historyButton)

        $(document).on('click', '.ql-undo', function () {
          editor.history.undo()
        })

        $(document).on('click', '.ql-redo', function () {
          editor.history.redo()
        })
      }
    } catch (error) {
      console.log('There is no Quill editor here')
    }
  }

  function scrollIntoApplyForm() {
    $(document).on('click', '.js-header-bottom__apply', function () {
      document.getElementById('apply').scrollIntoView()
    })
  }

  function init() {
    fileUploadCV()
    coverLetterQuillEditor()
    scrollIntoApplyForm()
  }

  init()
})